<template>
 <div>
   <header-sales></header-sales>
   <!-- pc view -->
   <div v-if='!mobileView'>
     <div id= "subheader">   </div> 
     <div id= "main-container"> 
        <div id= "label-container">
          <span id="label">Combos</span>
        </div> 
        <div id= "container">
          <div id="list-container">
            <item-promocion id="list-prod" v-for="item in items" :item='item' @setItemPromocion="setPromo"></item-promocion>
          </div>
        </div> 
        <div id="btnContainer">
          <button id="btnAgregarProducto" @click="btnAgregarProducto">AGREGAR PRODUCTO</button>
          <button id="btnIrCarrito" @click="btnIrCarrito">IR AL CARRITO</button>
        </div> 
     </div> 
    <transition name="fadePro"> 
    <div v-show='showPopup'>
      <div id='back-popup'>
      </div>
      <div id='popup' style="height: 390px;">
        <div id='popup-btnClose-container'>
          <img id='btnClose' v-on:click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
        </div>
        <p id='popup-titulo'>Promoción</p>
        <div id='popup-container'> 
          <div id='popup-image-container'>
              <img style="width: 90%; height: 90%; object-fit: contain" :src="imagenProducto" >
          </div>
          <div id='popup-container-text'>
            <p id='popup-producto'>{{nombrePromo}}</p>
            <p id='popup-descripcion-producto'>{{descripcionPromo}}</p>

            <p style="font-size: 10px; color: #656E76; font-weight: bold; margin-top: 12px"> Contenido: </p>
            <div style="margin-left: 5px; margin-top: 2px; font-size: 10px; color: #656E76; font-weight: normal; height: 40px; overflow: auto;">
                <ul>
                    <li v-for="producto in productos">{{ producto }}</li>
                </ul>
            </div>


            <p id='popup-precio-unitario'>${{precioPromo | formatMoney}}</p>
            <span id='popup-cantidad-label'>CANTIDAD</span>  
            <input :class='{popupCantidad:cantValida,popupCantidadInv:!cantValida}' type="text" value="1" v-model='cantidadProducto' v-on:keyup="updateCantidad">
            <p style="font-size: 9px; color:#5C666F" v-show='limitePromo'>(max {{limiteMaxCantPromo}} packs)</p> 
            <div style="margin-top: 10px">
              <span id='popup-subtotal-label'>SUBTOTAL</span>
              <span id='popup-subtotal' style="font-size: 15px">${{cantidadProducto*precioPromo  | formatMoney}}</span>
            </div>
          </div>
        </div>
        <div id="btnContainerPopup" style="margin-top: 40px">
          <button @click="btnCerrarPopup"  id="btnCerrarPopup">CANCELAR</button>
          <button @click="btnAgregarPopup" id="btnAgregarPopup">AGREGAR AL CARRITO</button>
        </div> 
       </div> 
       </div> 
     </transition>
   </div>



   <!-- mobile view -->
   <div v-if='mobileView' style="margin-top: 40px">
      <div class="fv ct" style="width: 100vw; height:100vh;">
          <div class="fh cc" style="width: 100%; height:4%; background:#44C7F4; color:white; font: size 12px;">Combos</div>
          <div id="list-container" style="margin-top: 20px; height: 65%; overflow: auto">
            <item-promocion id="list-prod" v-for="item in items" :item='item' @setItemPromocion="setPromo"></item-promocion>
          </div>
          <div class="fh cc">
            <div class="btnMobile" style="background: white;color: #4969B2; border-style: solid; border-color: #4969B2;" @click="btnAgregarProducto">AGREGAR PRODUCTO</div>
            <div class="btnMobile" @click="btnIrCarrito">IR AL CARRITO</div>
          </div> 
      </div>
      <transition name="fadePro"> 
      <div v-show='showPopup' style="width: 100vw; height: 100vh">
        <div id='back-popup'>
        </div>
        <div id='popup' style="width: 96%; height: 390px">
          <div id='popup-btnClose-container'>
            <img id='btnClose' v-on:click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
          </div>
          <p id='popup-titulo'>Promoción</p>
          <div class="fh lc" style="width: 100%; margin-top: 20px"> 
            <div class="fh ct" style="width: 40%; height: 120px">
                <img id='imagenProducto-image' :src="imagenProducto" style="width: 90%" >
                <!-- <img style="width: 90%; height: 90%; object-fit: contain" :src="imagenProducto" > -->
            </div>
            <div class="fv ct" style="width: 60%; height: 120px;">
                <div class="fh cc" style="font-size: 25px; color:#5C666F">{{nombrePromo}}</div>
                <div class="fh cc" style="font-size: 15px; color:#5C666F; margin-top: 20px">{{descripcionPromo}}</div>
                <div class="fh cc" style="font-size: 15px; color:#5C666F">Precio: ${{precioPromo | formatMoney}}</div>
            </div>
          </div>
          <div class="fh lc" style="width: 100%; height: 40px;">
              <div style="margin-left: 40px; ; font-size: 12px">CANTIDAD</div>  
              <input :class='{popupCantidad:cantValida,popupCantidadInv:!cantValida}' type="text" value="1" v-model='cantidadProducto' v-on:keyup="updateCantidad">
              <div style="font-size: 9px; color:#5C666F" v-show='limitePromo'>(max {{limiteMaxCantPromo}} packs)</div> 
          </div>
          <div class="fh lc" style="width: 100%; height: 40px;">
              <div style="margin-left: 40px; font-size: 12px">SUBTOTAL</div>  
              <div id='popup-subtotal' style="font-size: 15px">${{cantidadProducto*precioPromo|formatMoney}}</div>
          </div>
          <div id="btnContainerPopup">
            <button @click="btnCerrarPopup"  id="btnCerrarPopup">CANCELAR</button>
            <button @click="btnAgregarPopup" id="btnAgregarPopup">AGREGAR AL CARRITO</button>
          </div> 
        </div> 
        </div> 
      </transition>
    </div>
 </div>

</template>
      
      
<script>
import axios from 'axios'
import HeaderSales from '@components/views/header.vue';
import ItemPromocion from '@components/views/promociones/itemPromociones.vue';
      
export default {
  name: 'Promociones',
  components:{
    'header-sales': HeaderSales,
    'item-promocion': ItemPromocion,
  },
      
  data() {
    return {
      showPopup:false,
      promocion:null,
      cantidadProducto:1, 
      cantValida:true,
      mobileView:false,
      productos: []
    }
  },
            
  computed: {
    items () {
      return this.$store.state.pedido.promociones;
    },

    nombrePromo () {
      if (this.promocion != null)
      {
        return this.promocion.Nombre;
      }
      else
      {
        return '';
      }
    },

    descripcionPromo () {
      if (this.promocion != null)
      {
        return this.promocion.Observacion;
      }
      else
      {
        return '';
      }
    },

    precioPromo () {
      if (this.promocion != null)
      {
        return this.promocion.PrecioPromocional;
      }
      else
      {
        return '';
      }
    },

    limitePromo () {
      if (this.promocion != null)
      {
        return this.promocion.TieneLimiteMaximo;
      }
      else
      {
        return false;
      }
    },

    limiteMaxCantPromo () {
      if (this.promocion != null)
      {
        return this.promocion.LimiteMaximo;
      }
      else
      {
        return 0;
      }
    },

    imagenProducto() {
      if ((this.promocion != null)&&(this.promocion.ImagenesUrl.length > 0)) {
        return this.promocion.ImagenesUrl[0] 
      }
      else {
        return '/dist/placeholder-producto.png'
      }
    }, 

  },
            
  methods: {

    onResize() {
       if (window.innerWidth > 600) 
       {
         this.mobileView=false;
       }
       else 
       {
         this.mobileView=true;
       }
     },

    updateCantidad() {
      var rex = new RegExp(/^\d+$/);
      if (rex.test(this.cantidadProducto))  
      {
        if (this.cantidadProducto > 0)
        {
          if (this.promocion.TieneLimiteMaximo)
          {
            if (this.cantidadProducto >this.promocion.LimiteMaximo)
            {
              this.cantValida = false
            }
            else
            {
              this.cantValida = true
            }
          }
          else
          {
            this.cantValida = true
          }
        }
        else
        {
          this.cantValida = false
        }
      }
      else
      {
        this.cantValida = false
      }
    },


    validar () {
      var rex = new RegExp(/^\d+$/);
      if (!rex.test(this.cantidadProducto))  
      {
        return false;
      }
      else
      {
        if (this.cantidadProducto < 1)
        {
          return false;
        }
        else
        {
          return true;
        }
      }  
    },

    setPromo (id) {
      var promo =  this.$store.state.pedido.promociones.find(e => e.Id == id );
      if (promo != null) {
        this.showPopup = true 
        this.promocion = promo
        this.productos = []
        this.promocion.Productos.forEach((p)=> {
           var prod = this.$store.state.pedido.productos.find((it) =>  {return it.Id == p.ProductoId});
           this.productos.push(p.Cantidad + ' x  '  + prod.Categorizacion2Nombre + ' / ' + prod.Nombre)
        });
      }  
    },

    btnAgregarProducto () {
      if (this.$store.state.pedido.tipoOperacion == 'pedido') {
        this.$router.push({name: 'realizarPedidoCat'});
      }
      else if (this.$store.state.pedido.tipoOperacion == 'presupuesto') {
        this.$router.push({name: 'realizarPresupuestoCat'});
      }
      else if (this.$store.state.pedido.tipoOperacion == 'devolucion') {
        this.$router.push({name: 'realizarDevolucionCat'});
      }
    },

    btnIrCarrito () {
      if (this.$store.state.pedido.tipoOperacion == 'pedido') {
        this.$router.push({name: 'pedido'});
      }
      else if (this.$store.state.pedido.tipoOperacion == 'presupuesto') {
        this.$router.push({name: 'presupuestos'});
      }
      else if (this.$store.state.pedido.tipoOperacion == 'devolucion') {
        this.$router.push({name: 'devoluciones'});
      }
    },

    btnCerrarPopup () {
      this.showPopup = false 
    },


    btnAgregarPopup () {
      if (this.validar())
      {
        if (this.promocion.TieneLimiteMaximo && this.cantidadProducto > this.promocion.LimiteMaximo )
        {
          var obj = {
                  txt:'La cantidad ingresada supera el límite máximo de unidades de la promoción',
                  txtBtnCancel:'',
                  txtBtnOk:'Aceptar',
                  fCancel:null,
                  fOk:null
                    }
          this.$store.commit('popup/open',obj);
        }
        else
        {
          var imagen = ''
          if ((this.promocion.ImagenesUrl != null) && (this.promocion.ImagenesUrl.length > 0)) {
              imagen = this.promocion.ImagenesUrl[0]
          }
          var nuevaPromo = {
                  id: 0,
                  idCategoria: '',
                  idSubcategoria: '',
                  producto: this.promocion.Nombre,
                  descripcion: this.promocion.Observacion, 
                  precio: this.promocion.PrecioPromocional, 
                  precioLista: this.promocion.PrecioHabitual,
                  cantidad: this.cantidadProducto, 
                  peso:this.promocion.Peso,
                  ImagenUrl: imagen,
                  promocionId:this.promocion.Id,
                  porcentajeDescuento:0,
                  unidadesMinimaVenta:1,
                  unidadesPorPedido:1,
                  tieneLimiteMaximo: this.promocion.TieneLimiteMaximo,
                  limiteMaximo: this.promocion.LimiteMaximo,
                  tipoOblea:1
          }
          this.$store.commit('pedido/agregarAPedido',nuevaPromo);
          if (this.$store.state.pedido.tipoOperacion == '') {
            this.$store.commit('pedido/saveTipoOperacion','pedido');
          }
          this.showPopup = false 
        }
      }
      else
      {
        var obj = {
                  txt:'El campo cantidad debe contener un valor numérico entero mayor a 0',
                  txtBtnCancel:'',
                  txtBtnOk:'Aceptar',
                  fCancel:null,
                  fOk:null
                  }
        this.$store.commit('popup/open',obj);
      }
    },
  },

    mounted () {
      this.$store.commit('loader/stop')
      this.onResize()
    },

    created() {
      window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
      window.removeEventListener('resize', this.onResize)
    }

}
      
      
</script>
            
<style scoped>
     

#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60); 
}



#popup{
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%,-50%);
width: 400px;
/* height: 350px; */
border-radius: 15px;
box-sizing: border-box;
background: #ffffff;
border-style: solid;
border-width: 1px;
border: 1px solid #dddddd;
}


#popup-btnClose-container{
  display: flex;            
  flex-direction:row;  
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;  
  justify-content: flex-end; 
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}


#popup-container{
  display: flex;            
  flex-direction:row;  
  width: 380px;
  height: 210px;
  background:  #ffffff

}

#popup-image-container{
  width: 160px;
  height: 150px;
  margin-top:20px; 
  display: flex;            
  justify-content: center;  
  align-items: center;

}

#popup-image{
  max-width: 90%;
  max-height: 90%;
}


#popup-producto{
 margin-top: 20px;
 font-size: 15px;
 color: #5C666F;
 font-weight: bold;
}

#popup-descripcion-producto{
 margin-top: 6px;
 font-size: 11px;
 color: #5C666F;
}

#popup-precio-unitario{
 margin-top: 14px;
 margin-bottom: 20px;
 font-size: 24px;
 font-weight: 500;
 color: #5C666F;
}

#popup-cantidad-label{
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}

#popup-subtotal-label{
 margin-top: 10px;
 font-size: 12px;
 color: #5C666F;
 font-weight: 500;
}



.popupCantidad{
 font-size: 12px;
 color: #5C666F;
 width: 40px;
 height:20px;
 margin-left: 80px;
 border-style: solid;
 border-radius: 5px;  
 border:none; 
 border-width: 1px;
 border: 1px solid #dddddd;
 text-align: center;
 outline: none;
}


.popupCantidadInv{
 font-size: 12px;
 color: #5C666F;
 width: 40px;
 height:20px;
 margin-left: 80px;
 border-style: solid;
 border-radius: 5px;  
 border:none; 
 border-width: 1px;
 border: 1px solid #ff0000;
 text-align: center;
 outline: none;
}


#popup-subtotal{
 font-size: 14px;
 margin-left: 80px;
 font-weight: 600;
 color: #5C666F;
}


#btnContainerPopup{
  height: 80px;
  display: flex;            
  flex-direction: row;  
  justify-content: center;  
  align-items: center;  
}

.btnMobile{
  display: flex;
  flex-direction:row; 
  justify-content: center; 
  align-items: center;
  width: 120px;
  height: 30px;
  margin-left: 5px;
  margin-right: 5px;
  font-size: 9px;
  border-style: solid;
  background: #44C7F4; 
  border-color: #44C7F4; 
  border-radius: 20px;  
  color: #ffffff;
  outline: none;
}

#btnCerrarPopup{
  width: 100px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
  color: #4969B2;
  background: #ffffff; 
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
}

#btnAgregarPopup{
  width: 160px;
  height: 40px;
  font-size: 10px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
  background: #44C7F4; 
  color: #ffffff;
  outline: none;
}

#btnCerrarPopup:hover { cursor: pointer; }
#btnAgregarPopup:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }


.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}

/*----------------------------------------------------------------------------------------------------*/
      
       #subheader {
       width: 100%;
       height: 35vh;
       background: linear-gradient(#005A9F , #1899D6);
       }
      
      #main-container{
        position: absolute;
        top: 55vh;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 700px;
        height: 85vh;
        }

        #label-container{
        width: 700px;
        height: 10vh;
        }

        #label{
        color:#ffffff;
        font-size: 27px;
        }

        #container{
        width: 700px;
        height: 65vh;
        padding-top: 35px;
        border-width: 1px;
        border: 1px solid #dddddd;
        box-sizing: border-box;
        /*box-shadow: 3px 3px 4px #dddddd;*/
        background-color: #ffffff;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }

        #list-container{
        width: 660px;
        height: 55vh;
        background: #ffffff;
        overflow: auto;
        display: flex;
        flex-direction:column; 
        align-items: center; 
        }
            
      #btnContainer{
        width: 660px;
        height: 10vh;
        display: flex;
        flex-direction:row; 
        justify-content: flex-end; 
        align-items: center; 
      }
           


      #btnAgregarProducto{
        width: 120px;
        height: 30px;
        font-size: 9px;
        margin-left: 5px;
        margin-right: 5px;
        border-style: solid;
        border:none; 
        color: #4969B2;
        background: #ffffff; 
        border-radius: 20px;  
        border-width: 1px;
        border: 1px solid #4969B2;
        outline: none;
      }


      #btnIrCarrito{
        width: 100px;
        height: 30px;
        margin-left: 5px;
        margin-right: 5px;
        font-size: 9px;
        border-style: solid;
        border:none; 
        background: #44C7F4; 
        border-radius: 20px;  
        color: #ffffff;
        outline: none;
      }

      #btnAgregarProducto:hover{cursor: pointer;}
      #btnIrCarrito:hover{cursor: pointer;}
          


     /* width */
      ::-webkit-scrollbar {
          width: 5px;
      }

      /* Track */
      ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px #dddddd; 
          border-radius: 10px;
      }
      
      /* Handle */
      ::-webkit-scrollbar-thumb {
          background: #bbbbbb; 
          border-radius: 10px;
      }

      /* Handle on hover */
      ::-webkit-scrollbar-thumb:hover {
          background: #cccccc; 
      }

      
      
    </style>


// WEBPACK FOOTER //
// src/components/views/promociones/promociones.vue